export * from './src/cloud-autocms-v3-collection-metadata-autocms.universal.js';
